import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ExceptionState } from 'src/shared/components/exceptionState';
import { Image } from 'src/shared/components/image';
import ErrorStateImage from 'public/assets/images/errorState.svg';
export const Error = () => {
    const { t } = useTranslation();
    return (_jsxs(ExceptionState, { className: "my-6", children: [_jsx(Image, { src: ErrorStateImage, alt: "" }), _jsx(ExceptionState.Description, { classNames: "mb-2 mt-4", children: t('modules.form.classes.error') }), _jsx(ExceptionState.Button, { children: t('general.try_again') })] }));
};
